import React, { useState } from 'react'
import gql from 'graphql-tag'
import { withApollo } from 'react-apollo'
import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'
import IconButton from '@material-ui/core/IconButton'
import EditIcon from '@material-ui/icons/Edit'
import TextField from '@material-ui/core/TextField'
import Button from '@material-ui/core/Button'
import Grid from '@material-ui/core/Grid'

const UPDATE_FUNERAL_PERCENTAGES = gql`
  mutation UpdateBeneficiaryPercentages($id: String!, $input: UpdateFuneralInput!) {
    updateFuneral(id: $id, input: $input) {
      id
      beneficiaries {
        id
        payoutType
        percentage
        payToId
        payTo {
          id
          firstNames
          surname
        }
      }
    }
  }`

const EditBeneficiaryPercentages = ({ client, funeralId, beneficiaries, refetchQueries }) => {
  const [open, setOpen] = useState(false)
  const [percentages, setPercentages] = useState({})
  const [saving, setSaving] = useState(false)

  const handleOpen = () => {
    const initial = {}
    beneficiaries.forEach(b => { initial[b.id] = b.percentage })
    setPercentages(initial)
    setOpen(true)
  }

  const handleClose = () => {
    if (saving) return
    setOpen(false)
  }

  const total = beneficiaries.reduce((sum, b) => sum + (Number(percentages[b.id]) || 0), 0)
  const isValid = total === 100

  const handleSave = () => {
    setSaving(true)
    const input = {
      beneficiaries: beneficiaries.map(b => ({
        id: b.id,
        payToId: b.payToId,
        percentage: Number(percentages[b.id]) || 0,
        payoutType: b.payoutType,
        bankAccountId: b.bankAccount ? b.bankAccount.id : undefined,
      })),
    }
    client.mutate({
      mutation: UPDATE_FUNERAL_PERCENTAGES,
      variables: { id: funeralId, input },
      refetchQueries,
    }).then(() => {
      setSaving(false)
      setOpen(false)
    }).catch(() => setSaving(false))
  }

  return (
    <>
      <IconButton size="small" aria-label="edit beneficiary percentages" onClick={handleOpen}>
        <EditIcon style={{ fontSize: 16, color: '#D5D5D5' }} />
      </IconButton>
      <Dialog open={open} onClose={handleClose} maxWidth="xs" fullWidth>
        <DialogTitle>Edit beneficiary percentages</DialogTitle>
        <DialogContent>
          <Grid container direction="column" spacing={2}>
            {beneficiaries.map(b => (
              <Grid item key={b.id}>
                <TextField
                  fullWidth
                  type="number"
                  label={b.payTo ? `${b.payTo.firstNames} ${b.payTo.surname}` : 'Beneficiary'}
                  value={percentages[b.id] != null ? percentages[b.id] : ''}
                  onChange={e => setPercentages({ ...percentages, [b.id]: e.target.value })}
                />
              </Grid>
            ))}
          </Grid>
          <div style={{ marginTop: 16, fontWeight: 600, fontSize: 13 }}>Total: {total}%</div>
          {!isValid && (
            <div style={{ color: '#c0392b', marginTop: 4, fontSize: 13 }}>
              Percentages must add up to 100% to save
            </div>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} disabled={saving}>Cancel</Button>
          <Button color="primary" variant="contained" disabled={!isValid || saving} onClick={handleSave}>Save</Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default withApollo(EditBeneficiaryPercentages)
